import type { AcuityApproversResponse } from "@/core/types";
import { api } from "@/api";

export async function getAcuityApprovers(): Promise<AcuityApproversResponse> {
  return api.acuityTyped.get_approvers({ params: { showLoader: false } });
}
